export default __webpack_public_path__ + "static/media/warning.e40dc638.svg";